module.exports = __webpack_public_path__ + "Flag-860.183fa878c9e058b287c7c3752d145c3b.svg";